export default __webpack_public_path__ + "static/media/124.3d5f462e.png";